<script>

  import items from '../data/items.js';

  export let modalVisible;
  export let toggleModal;
  export let updateActive;
  export let showIntroduction = true;

  function menuSelect(i) {
    updateActive(i);
    toggleModal();
  }

  function enter(i) {
    let ci,cj;
    document.querySelectorAll('.item').forEach((item, j) => {
      if (i!=j) {
        cj = items[j].color;
        ci = items[i].color;
        item.style.boxShadow = `inset 0 0 0 3px ${ci}`;
        item.style.background = "#f8f5ef";
        item.style.color = ci;
      }
    });
  }

  function leave(i) {
    document.querySelectorAll('.item').forEach((item, j) => {
      item.style.color = "white";
      item.style.background = items[j].color;
      item.style.boxShadow = "none";
    });
  }

</script>

<style type="text/sass">

$color-crm: #f8f5ef

@keyframes grow
  0%
    transform: scale(0)
  100%
    transform: scale(1)

.modal
  position: absolute
  z-index: 1
  opacity: 1
  min-height: 100vh
  max-height: 100vh
  background: #000c
  padding: 5%
  box-sizing: border-box
  font-size: 20px
  line-height: 1.5
  transition-duration: 0.5s

  &.hidden
    pointer-events: none
    opacity: 0

.home-btn
  position: fixed
  width: 50px
  height: 50px
  box-sizing: border-box
  border-radius: 50%
  background: #323838
  line-height: 62px
  text-align: center
  transform-origin: center
  animation: grow 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) 1 forwards
  box-shadow: 0 2px 10px 0 #32383855
  transition-duration: 0.3s
  right: 60px
  bottom: 60px

  &:hover
    background: #121808
    box-shadow: 0 4px 5px 0 #323838cc

.introduction
  background: $color-crm
  padding: 5%
  font-size: .9em

.logo
  width: 55%
  min-width: 110px
  display: inline-flex
  padding: 1em 0

  h1
    font-size: 1.4em
    line-height: 1.2
    flex-basis: 45%
    width: 45%
    margin-right: 20px

  svg
    overflow: visible
    flex-basis: 55%
    width: 55%

    path
      fill: black

.menu
  color: white
  text-transform: uppercase
  white-space: nowrap
  user-select: none
  font-weight: 600
  font-size: 1.2em

.item
  transition-duration: 0.1s
  &:not(:first-child)
    margin-top: -3px

.fill-h
  min-height: 100%
  max-height: 100%

.fill-w
  min-width: 100%
  max-width: 100%

.flex
  display: flex

.flex-ch
  display: flex
  flex-direction: row
  align-items: center
  justify-content: center

.flex-cv
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center

.flex-1
  flex: 1

.ptr
  cursor: pointer

.hide
  display: none

.cta
  font-size: 0.9em

  a
    color: #0042A6
    background: $color-crm
    text-decoration: none
    font-weight: 600
    letter-spacing: 0.03em
    box-shadow: 0 2px 0 0 #0042A6
    transition-duration: 0.25s

    &:hover
      box-shadow: 0 0 0 3px #0042A6
      background: #0042A6
      color: white

@media (max-width: 800px)

  .modal
    min-height: 200vh
    max-height: 200vh
    flex-direction: column
    padding: 0
    line-height: 1.4


  .introduction
    box-sizing: border-box
    max-height: 100vh
    font-size: 18px

@media (max-width: 900px)

  .home-btn
    display: none

@media (max-width: 450px)

  .logo
    width: 65%

  .introduction
    font-size: 15px

</style>

<div class="home-btn ptr" on:click={toggleModal} class:hide="{modalVisible}">
  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="white" d="M12 3s-6.186 5.34-9.643 8.232c-.203.184-.357.452-.357.768 0 .553.447 1 1 1h2v7c0 .553.447 1 1 1h3c.553 0 1-.448 1-1v-4h4v4c0 .552.447 1 1 1h3c.553 0 1-.447 1-1v-7h2c.553 0 1-.447 1-1 0-.316-.154-.584-.383-.768-3.433-2.892-9.617-8.232-9.617-8.232z"/></svg>
</div>

<div
  class:hidden="{!modalVisible}"
  class="modal flex fill-w"
>

  {#if showIntroduction}
    <div class="introduction fill-h flex-1 flex-cv">
      <div class="logo">
        <h1>Happy<br>Days<br>Project</h1>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 226.92 117.99"><title>Logo_Flag</title><path d="M165,70.48c0,3.32,2.77,4,5.53,4,4.13,0,7.94-2.44,7.94-5.93V65C168.92,65,165,67.3,165,70.48Z" fill="#0042A6"/><path d="M0,0V118l226.92-10.71V10.72ZM62.79,83.62l-9-14.69-5.6,5.43v9.26H32V24.71H48.16V57.16L61.87,40.77H80.7L64.9,58.06,81.13,83.65Zm73.19,0H122.75l-1.06-6.49a18.93,18.93,0,0,1-15.24,7.53c-10.15,0-14.93-5.93-14.93-16.08V40.77h16.15V66.58c0,3.57,1.86,6,5.43,6a6.57,6.57,0,0,0,6.73-6.39V40.77H136ZM200.16,83a19.13,19.13,0,0,1-8.44,1.63c-6.49,0-10.53-2.13-11.93-5.36A24.1,24.1,0,0,1,164,84.6c-8.92,0-15-3.09-15-12,0-12.83,10.88-15.27,29.62-15.27v-2.1c0-3.49-2.75-5.12-6.24-5.12-2.85,0-6.17.9-6.17,3.73v.33h-16a6.19,6.19,0,0,1-.08-1.14c0-7.87,7.71-13.21,22.4-13.21,11.77,0,22.15,3.4,22.15,13.95V70.48c0,1.77.81,3.16,2.6,3.16h2.92Z" fill="#0042A6"/></svg>
      </div>
      <p>Kua believes all businesses have the potential to create happier days for people, the planet and the future.</p>
      <p>In 2020, we launched the Happy Days Project to better understand what it means to be a world-positive business.</p>
      <p>We spoke with experts across topics that have challenged us most. Realising that our learnings were applicable beyond Kua, we built this platform to share the conversations. We hope the lessons inspire you as much as they did us.</p>
      <p class="cta">Questions? Coffee? <a target="_blank" href="https://kuacoffee.co/contact/">Hello.</a></p>
    </div>
  {/if}

  <div class="menu fill-h flex-1 flex-cv">
    {#each items as item, i}
      <div
        class="item ptr fill-w flex-ch flex-1"
        style="background: {item.color}"
        on:click|stopPropagation="{ () => menuSelect(i) }"
        on:mouseenter="{ () => enter(i) }"
        on:mouseleave="{ () => leave(i) }"
      >
        {item.name}
      </div>
    {/each}
  </div>
</div>
